import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form, Field } from 'formik';
import { toFormikValidationSchema } from 'zod-formik-adapter';
import Grid from 'apollo-react/components/Grid';
import TextField from 'apollo-react/components/TextField';
import { personalInfoSchema } from '../../../../validation/profileValidation';
import { renderInputComponent } from '../../Form/renderInputComponent';
import ButtonCommon from '../../Button';
import ProfileFieldDisplay from './ProfileFieldDisplay';
import ProfileEditActions from './ProfileEditActions';
import styles from '../Profile.module.css';

const PersonalInfoSection = ({
  userData,
  form,
  setForm,
  editing,
  onStartEdit,
  onStopEdit,
  onSave,
  onDiscard,
  fields,
  canEdit,
}) => {
  const { t } = useTranslation();

  if (!editing) {
    return (
      <>
        <div className={styles.divider} />
        <ProfileFieldDisplay label={t('ID')} value={userData.id} />
        <ProfileFieldDisplay
          label={t('profileData.userName')}
          value={form.username}
        />
        {canEdit && (
          <div className={styles.actionsRight}>
            <ButtonCommon
              color="primary"
              className={styles.btnSized}
              onClick={onStartEdit}
              text={t('edit')}
            />
          </div>
        )}
      </>
    );
  }

  return (
    <Formik
      initialValues={{ username: form.username }}
      validationSchema={toFormikValidationSchema(personalInfoSchema(t))}
      enableReinitialize
      onSubmit={async () => {
        const success = await onSave('personal');
        if (success) onStopEdit();
      }}
    >
      {({ setFieldValue, handleSubmit }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label={t('ID')}
                value={userData.id}
                disabled
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              {fields.map((field) => (
                <Field key={field.name} name={field.name}>
                  {({ field: formikField, meta }) =>
                    renderInputComponent(
                      field,
                      { username: form.username },
                      formikField,
                      meta,
                      (value) => {
                        setFieldValue(formikField.name, value);
                        setForm({ ...form, [formikField.name]: value });
                      }
                    )
                  }
                </Field>
              ))}
            </Grid>
          </Grid>
          <ProfileEditActions
            onDiscard={() => {
              onDiscard();
              onStopEdit();
            }}
            onSave={handleSubmit}
          />
        </Form>
      )}
    </Formik>
  );
};

export default PersonalInfoSection;
